<template>
  <div class="indexBox bg">
    <img class="WLJY_logo" v-if="matchId == 219 || matchId == 220 || matchId == 221 || matchId == 222|| matchId == 223" src="https://mc.posedu.com.cn/myAll_Img/WLJY_logo.png" />
    <img  :src="hostUrl" alt="" style="height: 4.8rem;position: absolute;left: 2.5rem;top: 2rem;" v-if="hostUrl">
    <img :src="technicalSupportUrl" alt="" style="height: 4.8rem;position: absolute;right: 2.5rem;top: 2rem;" v-if="hostUrl && technicalSupportUrl">
    <img  :src="technicalSupportUrl" alt="" style="height: 4.8rem;position: absolute;left: 2.5rem;top: 2rem;" v-if="!hostUrl && technicalSupportUrl">

    <div class="bigTitleBack bg">
      <div class="bigTitle">总分显示</div>
    </div>
    <div class="mainBack bg">
      <div class="title">{{serialNumber}}号选手最终得分</div>
      <div class="num">{{fraction}}</div>
    </div>
    <!-- <div class="numBox">
      <div v-if="countdown && countdown!='00:00'" :class="minute==0&& second<=10 && second>0 && suspend?'numRed numRed_animation':
        (minute==0 && second==0) || (minute==0 && second<=10 && !suspend)?'numRed':'num'">
        {{minute<10?'0'+minute:minute}}:{{second<10?'0'+second:second}}</div>
    </div> -->
    <div class="bottomBox">
      <img class="Decoration" src="https://mc.posedu.com.cn/myAll_Img/bot_left_Decoration.png" />
      <img class="Decoration" src="https://mc.posedu.com.cn/myAll_Img/bot_right_Decoration.png" />
    </div>
    <audio id="myaudio" controls="controls" hidden src="https://mc.posedu.com.cn/myAll_Img/time_sound.mp3?1"
      ref="audio"></audio>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        countdown: null, //倒计时
        minute: '', //分钟
        second: '', //秒
        countdownGO_FunTime: null, // 倒计时函数

        fraction: '', //分数
        serialNumber: '', //序号
        matchId: 0,
        playerId: 0, //选手id
        mytype: '', //环节type
        pagesArr: ['/pages/index', '/pages/playerQuestions', '/pages/scoring', '/pages/playerRanking',
          '/pages/countdown', '/pages/totalScore_player'
        ], //首页banner、选题、打分、排行、倒计时、总分
        circulateFunTime: null,
        suspend: true, //倒计时是否进行中
        player_list:[],
            hostUrl:'',
        technicalSupportUrl:''
      };
    },
    mounted() {
      let that = this
      this.matchId = this.$route.query.matchId;

      this.$get(
          "gerSecondConsoleInfo", '?trackId=' + 1, {
            matchId: this.matchId,
          }
        )
        .then((res) => {
          console.log(res.data);
          this.mytype = res.data.type
          this.playerId = res.data.playerId
          this.countdown = res.data.countDownSeconds
          this.minute = parseInt(this.countdown.split(':')[0])
          this.second = parseInt(this.countdown.split(':')[1])
          setTimeout(() => {
            that.data_acquisition()
            that.grade_final_gradeFun()
          }, 1000);
        })
        .catch((err) => {});
        this.hostUrl = sessionStorage.getItem('hostUrl')
        this.technicalSupportUrl = sessionStorage.getItem('technicalSupportUrl')
    },
    destroyed() {
      let that = this
      this.$refs.audio.pause(); //停止
      window.clearTimeout(that.circulateFunTime)
      window.clearInterval(that.countdownGO_FunTime)
    },
    methods: {
      //缓存数据
      // asdas() {
      //   this.$get("getCache", '?trackId=' + 1, {
      //     matchId: this.matchId,
      //   }).then((res) => {
      //     this.player_list = res.data.player_list
      //     //console.log('getCache', res.data);
      //     for (let i = 0; i < res.data.player_list.length; i++) {
      //       if(res.data.player_list[i].id == this.playerId){
      //         this.serialNumber = res.data.sort
      //       }
      //     }
      //   })
      // },
      // 倒计时
      countdownGO_Fun() {
        this.suspend = true
        let that = this
        //console.log("minute_second", this.minute, this.second);
        that.countdownGO_FunTime = window.setInterval(() => {
          if (that.second > 0) {
            that.second -= 1
            if (that.minute == 0 && that.second <= 10 && this.$store.state.audioShow == 1) {
              that.radioFun()
            }
          } else {
            if (that.minute > 0) {
              that.minute -= 1
              that.second = 59
              if (that.minute == 0 && that.second == 59 && this.$store.state.audioShow == 1) {
                that.radioFun()
              }
            } else {
              window.clearInterval(that.countdownGO_FunTime)
            }
          }
        }, 1000)
      },
      radioFun() {
        this.$refs.audio.currentTime = 0; //从头开始播放
        this.$refs.audio.play(); //播放
        setTimeout(() => {
          this.$refs.audio.pause(); //停止
        }, 800);
      },
      grade_final_gradeFun() {
        this.$post(
            "grade_final_grade", {}, {
              matchId: this.matchId,
            }
          )
          .then((res) => {
            //console.log('总分', res.data);
            this.fraction = res.data.score
            this.serialNumber = res.data.num
          })
          .catch((err) => {});
      },
      data_acquisition() {
        this.$get("gerSecondConsoleInfo", '?trackId=' + 1, {
            matchId: this.matchId,
          }).then((res) => {
            sessionStorage.setItem('screenModal', res.data.currentScreenModal?res.data.currentScreenModal:1)
            if(res.data.currentScreenModal && res.data.currentScreenModal!=1){
              window.location.reload();
            }
            //console.log('gerSecondConsoleInfo', res.data);
            let that = this
            if (res.data.type == 6) {
              if (this.playerId == res.data.playerId) {
                if (res.data.countDownStatus == 0) {
                  window.clearInterval(that.countdownGO_FunTime)
                  this.suspend = false
                  this.countdown = res.data.countDownSeconds
                  this.minute = parseInt(this.countdown.split(':')[0])
                  this.second = parseInt(this.countdown.split(':')[1])
                } else if (res.data.countDownStatus == 1) {
                  if (this.minute == parseInt(this.countdown.split(':')[0]) && this.second == parseInt(this.countdown
                      .split(':')[1])) {
                    this.countdownGO_Fun()
                  }
                } else if (res.data.countDownStatus == 2) {
                  window.clearInterval(that.countdownGO_FunTime)
                  this.suspend = false
                  this.countdown = this.minute + ':' + this.second
                }
              } else {
                window.clearInterval(that.countdownGO_FunTime)
                this.mytype = res.data.type
                this.playerId = res.data.playerId
                this.countdown = res.data.countDownSeconds
                this.minute = parseInt(this.countdown.split(':')[0])
                this.second = parseInt(this.countdown.split(':')[1])
              }
              this.circulateFunTime = window.setTimeout(() => {
                that.data_acquisition()
                that.grade_final_gradeFun()
              }, 1000);
            } else {
              window.clearTimeout(that.circulateFunTime)
              let routerNum = null
              if (res.data.type == null) {
                routerNum = 0
              } else if (res.data.type == 4) {
                routerNum = 1
              } else if (res.data.type == 3 || res.data.type == 5 || res.data.type == 10) {
                routerNum = 2
              } else if (res.data.type == 9) {
                routerNum = 3
              } else if (res.data.type == 1 || res.data.type == 2 || res.data.type == 7) {
                routerNum = 4
              }
              if (routerNum != null) {
                this.$router.push({
                  path: this.pagesArr[routerNum],
                  query: {
                    matchId: this.matchId,
                    soundOver: true
                  },
                });
                window.clearTimeout(that.circulateFunTime)
              }
            }
          })
          .catch((err) => {});
      },
    }
  }

</script>
<style scoped>
  * {
    padding: 0;
    margin: 0;
  }

  body {
    margin: 0;
    padding: 0;
  }

  .indexBox {
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    flex-direction: column;
    background-image: url(https://mc.posedu.com.cn/myAll_Img/backOne.png);
    overflow: hidden;
  }

  .bigTitleBack {
    background-image: url(https://mc.posedu.com.cn/myAll_Img/bigTitle.png);
    font-size: 2.8125rem;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    width: 70.9375rem;
    height: 5rem;
    display: flex;
    justify-content: center;

  }

  .bigTitleBack .bigTitle {
    color: #4997FE;
    background-image: -webkit-linear-gradient(top, #79CBFB, #4997FE);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .mainBack {
    width: calc(100% - 16.25rem);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 3.125rem 1.875rem 0;
    position: relative;
    margin-top: 14vh;
  }

  .mainBack .title {
    font-size: 6.25rem;
    font-family: DIN Condensed-Bold, DIN Condensed;
    color: #ADFFFD;
    line-height: 1.875rem;
    margin-bottom: 17vh;
  }

  .mainBack .num {
    font-size: 25rem;
    font-family: DIN Condensed-Bold, DIN Condensed;
    font-weight: bold;
    line-height: 25rem;
    color: #ADFFFD;
    background: linear-gradient(180deg, #DCFFFF 0%, #00DFDA 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

  }


  .bottomBox {
    margin-top: 7vh;
    width: calc(100% - 18.75rem);
    display: flex;
    justify-content: space-between;
  }

  .Decoration {
    height: 6.25rem;
  }

  .numBox {
    position: fixed;
    right: 5.4375rem;
    top: 3.125rem;
  }

  .numBox .num {
    font-size: 7rem;
    font-family: DIN Condensed-Bold, DIN Condensed;
    font-weight: bold;
    text-align: center;
    color: #1B6DC1;
    background: linear-gradient(180deg, #A5F9F9 0%, #1B6DC1 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .numBox .numRed {
    font-size: 7rem;
    font-family: DIN Condensed-Bold, DIN Condensed;
    font-weight: bold;
    text-align: center;
    color: #FF0000;
    background: linear-gradient(180deg, #FB7474 0%, #FF0000 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

</style>



// WEBPACK FOOTER //
// src/pages/totalScore_player.vue